export function syQuerySelector(selectors: string, root: Element = document.body): Element | null {
  let stack: Element[] = [root];
  while (stack.length > 0 && stack[0] !== null) {
    const current = stack[0];
    stack.splice(0, 1); // Remove current element from stack

    if (current.matches(selectors)) {
      return current;
    }
    const children = Array.from(current.children || []);
    const shadowChildren = Array.from(current.shadowRoot?.children || []);
    stack = children.concat(shadowChildren, stack);
  }
  return null;
}

export function syQuerySelectorAll(selectors: string, root: Element = document.body): Element[] | null {
  const elements: Element[] = [];

  let stack: Element[] = [root];
  while (stack.length > 0 && stack[0] !== null) {
    const current = stack[0];
    stack.splice(0, 1); // Remove current element from stack

    if (current.matches(selectors)) {
      elements.push(current);
      const children = Array.from(current.children || []);
      const shadowChildren = Array.from(current.shadowRoot?.children || []);
      stack = children.concat(shadowChildren, stack);
    } else {
      const children = Array.from(current.children || []);
      const shadowChildren = Array.from(current.shadowRoot?.children || []);
      stack = children.concat(shadowChildren, stack);
    }
  }

  if (elements.length > 0) {
    return elements;
  }

  return null;
}
